module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "header",
    class: {
      'header--home': _vm.$route.path === '/' && !_vm.$store.state.menu, 'header--family-fun-event': _vm.$route.path.includes('/mouth-guard-registration'), 'header--retainer-program': _vm.$route.path.includes('/retainer-program'), 'header--exit-interview': _vm.$route.path.includes('/exit-interview'), 'header--smile-assurance': _vm.$route.path.includes('/smile-assurance-program'), 'header--thank-you': _vm.$route.path.includes('/thank-you'), 'header--adminlink': _vm.$route.path.includes('/admin-links'), 'header--review': _vm.$route.path.includes('/review') || _vm.$route.path.includes('/accessibility') || _vm.$route.path.includes('/mouth-guard-thank-you') || _vm.$route.path.includes('/feedback')
    },
    attrs: {
      "id": "head"
    }
  }, [_c('v-waypoint', {
    staticClass: "header__waypoint",
    on: {
      "waypoint-out": _vm.scrollOut,
      "waypoint-in": _vm.scrollIn
    }
  }), (_vm.props) ? _c('Menu', {
    staticClass: "header__menu--desktop",
    class: {
      'header__menu--thank-you': _vm.$route.path.includes('/thank-you'), 'header__menu--adminlink': _vm.$route.path.includes('/admin-links'), 'header__menu--exit-interview': _vm.$route.path.includes('/exit-interview'), 'header__menu--review': _vm.$route.path.includes('/review'), 'header__menu--smile-assurance': _vm.$route.path.includes('/smile-assurance-program'), 'header__menu--retainer-program': _vm.$route.path.includes('/retainer-program') || _vm.$route.path.includes('/mouth-guard-thank-you') || _vm.$route.path.includes('/feedback') || _vm.$route.path.includes('/accessibility')
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "home-fade"
    }
  }, [_c('HomeHero', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/" && !_vm.$store.state.menu),
      expression: "$route.path === \"/\" && !$store.state.menu"
    }],
    attrs: {
      "props": _vm.props
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('HeroPages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/covid-19-updates") && !_vm.$store.state.menu),
      expression: "$route.path.includes(\"/covid-19-updates\") && !$store.state.menu"
    }],
    attrs: {
      "props": _vm.covid
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('HeroPages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/virtual-services") && !_vm.$store.state.menu),
      expression: "$route.path.includes(\"/virtual-services\") && !$store.state.menu"
    }]
  })], 1), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('HeroPages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/videos") && !_vm.$store.state.menu),
      expression: "$route.path.includes(\"/videos\") && !$store.state.menu"
    }]
  })], 1), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('HeroPages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/virtual-consultation") && !_vm.$store.state.menu),
      expression: "$route.path.includes(\"/virtual-consultation\") && !$store.state.menu"
    }]
  })], 1), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('HeroPages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/7-and-up") && !_vm.$store.state.menu),
      expression: "$route.path.includes(\"/7-and-up\") && !$store.state.menu"
    }]
  })], 1), _c('HeroMobile', {
    attrs: {
      "props": _vm.props
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c231506","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 678
// module chunks = 1